import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useAtomValue } from 'jotai';

import type {
  TArchProcedureNames,
  TProcedureStatus,
} from '../../../../../react-query/useVisitSummaries';
import { Aligner } from '../../../../../svgs/Aligner';
import { selectedCountsFilterAtom } from '../../../atoms';
import { getIsVisualizationFilteredOut } from '../utils';

export const MouthArchIndicator = ({
  module,
  visualizationName,
  visualizationStatus,
}: {
  module?: 'image-viewer' | 'patient-list';
  visualizationName?: TArchProcedureNames;
  visualizationStatus?: TProcedureStatus;
}) => {
  const selectedCountsFilter = useAtomValue(selectedCountsFilterAtom);

  const getIconBgColor = (status?: TProcedureStatus) => {
    const isDarkMode = module === 'image-viewer';

    switch (status) {
      case 'recommended':
        return isDarkMode ? 'vai-bg-violet-700' : 'vai-bg-purple-700';
      case 'unscheduled':
        return 'vai-bg-red-500';
      case 'scheduled_today':
      case 'scheduled_future':
        return isDarkMode ? 'vai-bg-slate-500' : 'vai-bg-slate-400';
      case 'completed':
        return isDarkMode ? 'vai-bg-sapphire-500' : 'vai-bg-aqua-400';
      default:
        return isDarkMode ? 'vai-bg-slate-800' : 'vai-bg-zinc-200';
    }
  };

  const isFilteredOut = getIsVisualizationFilteredOut(
    visualizationName,
    visualizationStatus,
    selectedCountsFilter,
    module,
  );

  const isAlignerOpportunity =
    visualizationName === 'aligner' && visualizationStatus === 'recommended';

  if (isAlignerOpportunity) {
    return (
      <div className={classNames({ 'vai-opacity-45': isFilteredOut })}>
        <Aligner />
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'vai-flex vai-items-center vai-justify-center vai-rounded-full vai-text-slate-50 vai-h-3 vai-w-3',
        getIconBgColor(visualizationStatus),
        { 'vai-opacity-45': isFilteredOut },
      )}
    >
      <FontAwesomeIcon
        className="vai-h-2 vai-w-2 vai-text-slate-50"
        icon={faPlus}
      />
    </div>
  );
};
